import { classNames } from "primereact/utils";

const TRANSITIONS = {
    overlay: {
        timeout: 150,
        classNames: {
            enter: 'opacity-0 scale-75',
            enterActive: 'opacity-100 !scale-100 transition-transform transition-opacity duration-150 ease-in',
            exit: 'opacity-100',
            exitActive: '!opacity-0 transition-opacity duration-150 ease-linear'
        }
    }
};

     
const autocomplete = {
    root: ({ props }) => ({
        className: classNames(
            'relative flex flex-col',
            {
                'opacity-60 select-none pointer-events-none cursor-default': props.disabled
            },
            { 'w-full': props.multiple }
        )
    }),
    container: {
        className: classNames(
            'm-0 list-none cursor-text overflow-hidden flex items-center flex-wrap w-full',
            'px-3 py-2 gap-2',
            'font-sans text-base text-gray-700 dark:text-white/80 bg-white dark:bg-gray-900 border border-gray-300 dark:border-blue-900/40  transition duration-200 ease-in-out appearance-none rounded-md',
            'focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] hover:border-blue-500 focus:outline-none dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]'
        )
    },
    inputToken: {
        className: classNames('py-0.375rem px-0', 'flex-1 inline-flex')
    },
    input: ({ props }) => ({
        root: {
            className: classNames(
                'm-0',
                'transition-colors duration-200 appearance-none !rounded-[32px]',
                { 'rounded-tr-none rounded-br-none': props.dropdown },
                {
                    'font-sans text-base text-gray-700 bg-white p-3 border border-grey-6 focus:outline-offset-0 focus:outline-allstate-light-blue focus:outline-4 hover:border-allstate-light-blue focus:outline-none':
                        !props.multiple,
                    'font-sans text-base text-gray-700 dark:text-white/80 border-0 outline-none bg-transparent m-0 p-0 shadow-none rounded-none w-full': props.multiple
                },
                {
                    'pl-10': props.iconPosition === 'left',
                    'pr-10': props.iconPosition === 'right'
                }
            )
        }
    }),
    token: {
        className: classNames('py-1 px-2 mr-2 bg-gray-300 dark:bg-gray-700 text-gray-700 dark:text-white/80 rounded-full', 'cursor-default inline-flex items-center')
    },
    dropdownButton: {
        root: 'rounded-tl-none rounded-bl-none'
    },
    panel: {
        className: classNames('bg-grey-1 text-gray-700 border-0 rounded-md', 'max-h-[200px] overflow-auto', 'dark:bg-gray-900 dark:text-white/80', 'mt-2', 'shadow-lg')
    },
    list: 'list-none m-0',
    item: ({ context }) => ({
        className: classNames('cursor-pointer font-normal overflow-hidden relative whitespace-nowrap', 'm-0 border-0  transition-shadow duration-200 rounded-none', {
            'text-gray-700 hover:text-gray-700 hover:bg-grey-2 active:bg-faded-blue dark:text-white/80 dark:hover:bg-gray-800': !context.selected,
            '!bg-warning-red text-gray-700 dark:text-white/80 dark:bg-gray-800/90 hover:text-gray-700 hover:bg-gray-200 dark:text-white/80 dark:hover:bg-gray-800': context.focused && !context.selected,
            'bg-blue-100 text-blue-700 dark:bg-blue-400 dark:text-white/80': context.selected,
            'bg-blue-50 text-blue-700 dark:bg-blue-300 dark:text-white/80': context.selected,
        })
    }),
    itemGroup: {
        className: classNames('m-0 p-3 text-gray-800 bg-white font-bold', 'dark:bg-gray-900 dark:text-white/80', 'cursor-auto')
    },
    loadingicon: {
        className: classNames('hidden absolute text-allstate-blue bg-white w-3 h-3 left-[14px] top-0 bottom-0 my-auto z-10')
    },
    emptymessage: {
        className: classNames('p-3'),
    },
    transition: TRANSITIONS.overlay
}
        

export default autocomplete;